<template>
  <div class="form-group">
    <h2 ref="contactForm">Contact Information</h2>
    <fieldset>
      <legend class="sr-only">Set contact information</legend>
      <div class="row">
        <div class="col-lg-6 col-sm-6 col-xs-12">
          <div class="form-control">
            <label for="checkoutEmail" class="form-label">Email Address</label>
            <input v-model="email"
                   @change="checkEmail"
                   type="email"
                   name="contact[email]"
                   autocomplete="email"
                   :class="{'is-invalid': errors.has('contact[email]') || errors.has('email')}"
                   id="checkoutEmail"
                   v-validate="'email|required'"
                   data-vv-as="Email Address">
            <span class="validation-errors"
                  v-for="error in errors.collect('contact[email]')">{{ error }}</span>
            <span class="validation-errors"
                  v-for="error in errors.collect('email')">{{ error }}</span>
          </div>
        </div>
        <div class="col-lg-6 col-sm-6 col-xs-12">
          <div class="form-control">
            <label for="checkoutPhone" class="form-label">Phone</label>
            <input v-model="phone" type="tel" name="contact[phone]"
                   id="checkoutPhone"
                   :class="{'is-invalid': errors.has('contact[phone]')}"
                   v-validate="'required|max:25'"
                   data-vv-as="Phone">
            <span class="validation-errors"
                  v-for="error in errors.collect('contact[phone]')">{{ error }}</span>
          </div>
        </div>
      </div>
      <div class="row" v-if="isShowPasswordForm">
        <div class="col-lg-6 offset-lg-3 col-sm-6 offset-sm-3 col-xs-12 password-form">
          <div class="form-control">
            <label class="form-label" for="password">Password</label>
            <input type="password" name="password" tabindex="1" id="password"
                   autocomplete="current-password"
                   ref="password-input"
                   :class="{'is-invalid': errors.has('password')}"
                   v-validate="isShowPasswordForm === true ? 'required' : ''"
                   v-model="password">
            <span v-show="errors.has('password')"
                  class="help text-danger">{{ errors.first('password') }}</span>
            <button class="btn btn-primary btn-block btn-login" type="button" @click="signInUser">
              Login
            </button>
            <a :href="forgotPasswordLink">Forgot your password?</a>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script>
import Vue from 'vue';
import CheckoutApi from '@support/checkoutApi';
import checkoutErrors from '@mixins/checkoutErrors';

export default Vue.extend({
  name: 'contactInformation',
  data: () => ({
    password: '',
  }),
  mixins: [checkoutErrors],
  inject: ['$validator'],
  computed: {
    email: {
      get() {
        return this.$store.state.contact.email;
      },
      set(value) {
        this.$store.commit('contact/setEmail', value);
      },
    },
    phone: {
      get() {
        return this.$store.state.contact.phone;
      },
      set(value) {
        this.$store.commit('contact/setPhone', value);
      },
    },
    isShowPasswordForm: {
      get() {
        return this.$store.state.contact.isShowPasswordForm;
      },
      set(p) {
        this.$store.commit('contact/setIsShowPasswordForm', p);
      },
    },
    isRequestProcessing: {
      get() {
        return this.$store.state.checkout.isRequestProcessing;
      },
      set(p) {
        this.$store.commit('checkout/setRequestProcessing', p);
      },
    },
    forgotPasswordLink() {
      return '/password/reset?email=' + this.email;
    },
  },
  watch: {
    isShowPasswordForm(value) {
      if (value === true) {
        this.$nextTick(() => {
          const element = this.$refs['password-input'];
          this.$scrollTo(element);
          element.focus();
        });
      }
    },
  },
  methods: {
    signInUser() {
      this.errors.clear();

      const {email, password} = this;
      this.signingUpUser = true;

      if (!email) {
        this.signingUpUser = false;
        return;
      }

      this.isRequestProcessing = true;

      CheckoutApi.login(email, password).then(response => {
        this.signingUpUser = false;
        if (response.data.status !== 'success') {
          this.$message({
            type: 'error',
            message: response.data.message,
          });
          return;
        }
        //Set the auth token because it can send the next requests without it.
        axios.defaults.headers.common = {'Authorization': `Bearer ${response.data.token}`};
        this.$message({
          type: 'success',
          message: response.data.message,
        });
        this.isFormBlocked = false;
        this.isShowPasswordForm = false;
        this.password = null;
        this.$validator.pause()
        window.__is_logged_in = true;
        window.location.reload();
      }).catch(error => {
        const message = _.get(error, 'response.data.message', 'Login or password is incorrect');
        this.errors.add({
          field: 'password',
          msg: message,
        });
      }).finally(() => {
        this.isRequestProcessing = false;
      });
    },
    checkEmail() {
      this.$store.commit('shipping/setEmail', this.email);

      this.isShowPasswordForm = false;

      this.$validator.errors.clear();

      CheckoutApi.checkEmail(this.email).then(response => {
        if (window.__is_logged_in || this.errors.has('email')) {
          return;
        }

        this.userMessage = response.data.message;
        if (response.data.status === 'exists') {
          this.isShowPasswordForm = true;
        } else if (response.data.status === 'success') {
          this.isShowPasswordForm = false;
        }
      }).catch((e) => {
        if (e?.response?.status === 422) {
          this.$setValidationErrorsFromResponse(e.response.data);
        } else {
          this.$handleError(e);
        }
      });
    },
  },
});
</script>

<style lang="scss" scoped>
.password-form {
  border: 1px solid #f56c6c;
  padding: 5px;
  box-shadow: 0 0 2px 2px rgba(#f56c6c, 0.7);
}


</style>
